import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage, Language } from '../../lib/i18n';
export function LanguageSelector() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div className="flex items-center gap-1.5 bg-white/5 hover:bg-white/10 transition-colors px-2 py-1.5 rounded-lg border border-white/10" data-id="element-2939" data-mp="2kgor4amvxl00">
      <Globe className="w-4 h-4 text-white/60" data-id="element-2940" data-mp="2fh2fu6qmaetu" />
      <select value={lang} onChange={e => setLang(e.target.value as Language)} className="bg-transparent text-white/80 text-sm font-bold outline-none cursor-pointer appearance-none pr-2 [&>option]:bg-[#141414] [&>option]:text-white" data-id="element-2941" data-mp="2air5zw0bo4bm">
        <option value="es" data-id="element-2942" data-mp="20t7jmgdehsc0">ES</option>
        <option value="en" data-id="element-2943" data-mp="1wrmbt9fq448o">EN</option>
        <option value="de" data-id="element-2944" data-mp="1wsno1h8h6wrz">DE</option>
        <option value="pt" data-id="element-2945" data-mp="1wpjcfysokyra">PT</option>
        <option value="zh" data-id="element-2946" data-mp="1rsj6dnvtzw06">中文</option>
      </select>
    </div>;
}